import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
} from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import Material from '../../types/api/material'

export const materialsApi = createApi({
    reducerPath: 'materialsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Materials'],
    endpoints: builder => ({
        getMaterials: builder.query<Strapi<Material>, EndpointQueryParameters | void>({
            query: getQuery('/materials'),
        }),
        createMaterial: builder.mutation<StrapiSingle<Material>, StrapiCreate<Material>>({
            query: body => ({
                url: '/materials',
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const { useGetMaterialsQuery, useLazyGetMaterialsQuery, useCreateMaterialMutation } =
    materialsApi
